<template>
  <Header />
  <ServiceProperty />
  <Service />
  <ServiceIcons />
  <Footer />
</template>
<script>
import Service from "@/components/Service/BIAndAnalytics/Service.vue";
import ServiceIcons from "@/components/Service/BIAndAnalytics/ServiceIcons.vue";
import ServiceProperty from "@/components/Service/BIAndAnalytics/ServiceProperty.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Service,
    ServiceIcons,
    ServiceProperty,
    Header,
    Footer,
  },
};
</script>
